export function resetScroll(selector) {
  const el = document.querySelector(selector);
  if (el && el.scrollTop > 0) {
    console.log("Resetting scroll on:", el.className);
    el.scrollTop = 0;
  } else {
    console.log("Fallback scroll reset on window");
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0; // For Safari
    document.body.scrollTop = 0; // For other browsers
  }
}
